/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const ContentScreenPresentationId = {
    // TODO : More PresentationId to be added
    CAST_DETAIL: 'CAST_DETAIL',

    GET_THIS_SHOW_DETAIL: 'GET_THIS_SHOW_DETAIL',

    INFO_DETAIL: 'INFO_DETAIL',

    MAY_ALSO_LIKE_DETAIL: 'MAY_ALSO_LIKE_DETAIL',

    MORE_INFO_DETAIL: 'MORE_INFO_DETAIL',

    ON_DEMAND_EPISODES_DETAIL: 'ON_DEMAND_EPISODES_DETAIL',

    ONE_PASS_OPTIONS_DETAIL: 'ONE_PASS_OPTIONS_DETAIL',

    RECORDING_OPTIONS_DETAIL: 'RECORDING_OPTIONS_DETAIL',

    RECOVER_RECORDING_DETAIL: 'RECOVER_RECORDING_DETAIL',

    SEASON_OR_YEAR_DETAIL: 'SEASON_OR_YEAR_DETAIL',

    UPCOMING_AIRING_DETAIL: 'UPCOMING_AIRING_DETAIL',

    UPCOMING_EPISODES_DETAIL: 'UPCOMING_EPISODES_DETAIL',

    WATCH_NOW_DETAIL: 'WATCH_NOW_DETAIL',

    WATCH_PREVIEW_DETAIL: 'WATCH_PREVIEW_DETAIL',
} as const;

export type ContentScreenPresentationId =
    (typeof ContentScreenPresentationId)[keyof typeof ContentScreenPresentationId];
